import { Component, inject } from '@angular/core';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { ScheduledNotificationActionType } from '../scheduled-notification';

@Component({
  selector: 'app-scheduled-notification-handler',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './scheduled-notification-handler.component.html',
  styleUrl: './scheduled-notification-handler.component.scss',
})
export class ScheduledNotificationHandlerComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);
  private readonly messageService = inject(MessageService);

  loading = false;
  ScheduledNotificationActionType = ScheduledNotificationActionType;
  confirmAction() {
    const body: any = {
      id: this.config.data.selectedNotification?.Id,
      title: this.config.data.selectedNotification?.Title,
      body: this.config.data.selectedNotification?.Body,
      dueDate: this.config.data.selectedNotification?.DueDate,
      dueTime: this.config.data.selectedNotification?.DueTime,
      statuse: this.config.data.selectedNotification?.Status.id,
    };

    this.loading = true;

    switch (this.config.data.actionId) {
      case ScheduledNotificationActionType.Cancel:
        body['actionType'] = ScheduledNotificationActionType.Cancel;
        break;
      case ScheduledNotificationActionType.SendNow:
        body['actionType'] = ScheduledNotificationActionType.SendNow;
        break;
      case ScheduledNotificationActionType.Resend:
        body['actionType'] = ScheduledNotificationActionType.Resend;
        break;
    }

    this.handleNotificationAction(body);
  }

  private handleNotificationAction(body: any) {
    this.requestBuilder.patch(`notifications/schedule-notification-handler`, body).subscribe({
      next: res => this.handleSuccess(res),
      error: error => this.handleError(error),
    });
  }

  private handleSuccess(res: any) {
    this.loading = false;
    this.ref.close({ confirmed: true });
  }

  private handleError(err: any) {
    this.loading = false;
    console.log(err);
    if (err.error?.message) {
      this.showError(err.error.message);
    }
  }

  showError(errorMessage: string) {
    this.messageService.add({
      severity: 'danger',
      summary: 'Something went wrong!',
      detail: errorMessage,
      life: 6000,
    });
  }
}
